import { Component, OnDestroy, OnInit } from '@angular/core';
import { LoginService } from '../../../../components/Authentication/auth/login.service';
import { LogoutService } from '../../../../components/Authentication/auth/logout.service';
import { AccountTypeService } from '../../../../services/account-type';
import { NavigationEnd, Router } from '@angular/router';
import { Location } from '@angular/common';
import { Subject, filter, takeUntil } from 'rxjs';
import { i18Service } from '../../../../services/i18service';
import { PetsService } from '../../../../services/pets';
import { PointOfSaleService } from '../../../../services/pos';
import { UserService } from './../../../../services/user';
interface MenuItem {
  label: string;
  icon: string;
  route: string;
  accessPage?: string;
  alwaysVisible?: boolean;
  hideIfAffiliation?: boolean;
  requiresRoleCheck?: () => boolean;
  showUpcomingBadge?: boolean;
}

@Component({
  selector: 'app-clinic',
  templateUrl: './clinic.component.html',
  styleUrl: './clinic.component.scss'
})

export class ClinicComponent implements OnInit, OnDestroy {

  sidebarClosed = false;
  private destroy$ = new Subject<void>();
  upcoming: any;
  tokenExists = false;
  cartItems: any[] = [];
  cartItemCount = 0;
  cartPopUp = false;
  showCart = true;
  languageDropdownOpen = false;
  hasPOSData = false;
  constructor(
    private i18: i18Service,
    private loginService: LoginService,
    private logoutService: LogoutService,
    private location: Location,
    private _vac: PetsService,
    public accountService: AccountTypeService,
    private router: Router,
    private UserService: UserService,
    private posService: PointOfSaleService
  ) {
    this.i18.init();
  }

  /* =========================
        GETTERS
  ========================== */

  get isAffiliation() {
    return this.accountService.isAffiliation();
  }

  /* =========================
        MENU CONFIG
  ========================== */

  private menuConfig: MenuItem[] = [

    { label: 'Pospage', icon: 'fa-solid fa-store', route: '/Pospage', accessPage: '7' },
    { label: 'clinic', icon: 'fa-solid fa-calendar-days', route: '/Clinic', accessPage: '2' },
    { label: 'all services', icon: 'fa-solid fa-stethoscope', route: '/AllServices', accessPage: '7' },
    { label: 'client pets', icon: 'fa-solid fa-paw', route: '/pets', accessPage: '2' },
    { label: 'myclients', icon: 'fa-solid fa-address-book', route: '/myclients', accessPage: '2' },
    { label: 'invoices', icon: 'fa-solid fa-receipt', route: '/Orders', accessPage: '5' },
    { label: 'financial', icon: 'fa-solid fa-wallet', route: '/dailyexpenses', accessPage: '1' },
    { label: 'employees', icon: 'fa-solid fa-id-badge', route: '/allemployees', accessPage: '0' },
    { label: 'Users', icon: 'fa-solid fa-users-gear', route: '/allusers', requiresRoleCheck: () => this.accountService.canManageUsers() },
    { label: 'Profile', icon: 'fa-solid fa-circle-user', route: '/Profile', alwaysVisible: true },
    { label: 'fingerprint', icon: 'fa-solid fa-fingerprint', route: '/fingerprint', alwaysVisible: true }

  ];
  getUserwarehouse(userId: string) {
    this.posService.getUserPOS(userId).subscribe({
      next: (data) => {
        const list = data ?? [];

        this.hasPOSData = list.length > 0;

        if (!this.accountService && this.router.url.includes('/Pospage')) {
          this.router.navigate(['/fingerprint']);
        }
      }
    });
  }
  get menuItems(): MenuItem[] {
    return this.menuConfig.filter(item => {

      // 1️⃣ role-based items
      if (item.requiresRoleCheck) {
        return item.requiresRoleCheck();
      }

      // 2️⃣ always visible
      if (item.alwaysVisible) return true;

      // 3️⃣ access page based
      if (!item.accessPage) return false;

      const hasAccess = this.accountService.hasAccess(item.accessPage);

      return hasAccess &&
        !(item.hideIfAffiliation && this.isAffiliation);
    });
  }

  loadUpcoming(): void {
    const warehouseId = Number(localStorage.getItem('posId'));
    if (!warehouseId) {
      this.upcoming = 0;
      return;
    }

    this._vac.getUpcomingVaccinations(warehouseId).subscribe({
      next: (res) => {
        this.upcoming = res.count;

      },
      error: (err) => {
      },
    });
  }
  /* =========================
        LIFECYCLE
  ========================== */

  ngOnInit(): void {

    this.loginService.token$
      .pipe(takeUntil(this.destroy$))
      .subscribe(token => {
        this.tokenExists = !!token;
        if (token) {
          this.accountService.getAccountType().subscribe({
            next: () => {
              this.initializeUserState();
            },
            error: (err) => {
              console.error('Failed to load account type', err);
            }
          });
        }
      });

    this.router.events
      .pipe(
        filter(event => event instanceof NavigationEnd),
        takeUntil(this.destroy$)
      )
      .subscribe(() => {
        this.cartPopUp = false;
        this.updateCart();
        this.updateCartVisibility();
      });
    this.loadUpcoming();
    this.updateCart();
    this.updateCartVisibility();
  }
  private initializeUserState(): void {
    if (this.accountService.isSuperAdmin()) {
      this.hasPOSData = true;
      return;
    }

    this.UserService.getUserId().subscribe({
      next: (data) => {
        this.getUserwarehouse(data.user_id);
      }
    });
  }
  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  /* =========================
        CART
  ========================== */

  updateCart() {
    this.cartItems = this.readCartForCurrentWarehouse();
    this.cartItemCount = this.cartItems.length;
  }

  private readCartForCurrentWarehouse(): any[] {
    const currentWarehouseId = localStorage.getItem('posId');
    const cartWarehouseId = localStorage.getItem('cartWarehouseId');

    if (cartWarehouseId && currentWarehouseId && cartWarehouseId !== currentWarehouseId) {
      this.clearCartStorage();
      return [];
    }

    const storedCart = localStorage.getItem('cart');

    try {
      return storedCart ? JSON.parse(storedCart) : [];
    } catch {
      this.clearCartStorage();
      return [];
    }
  }

  private saveCartStorage(): void {
    if (!this.cartItems.length) {
      this.clearCartStorage();
      return;
    }

    const currentWarehouseId = localStorage.getItem('posId');
    localStorage.setItem('cart', JSON.stringify(this.cartItems));

    if (currentWarehouseId) {
      localStorage.setItem('cartWarehouseId', currentWarehouseId);
    }
  }

  private clearCartStorage(): void {
    localStorage.removeItem('cart');
    localStorage.removeItem('cartWarehouseId');
  }

  updateCartVisibility() {
    const path = this.location.path();
    this.showCart = !path.includes('/Addorder') && !path.includes('/Home');
  }

  removeFromCart(item: any) {
    this.cartItems = this.cartItems.filter(i => i.id !== item.id);
    this.saveCartStorage();
    this.updateCart();
    if (!this.cartItems.length) this.cartPopUp = false;
  }

  cartPopUpOpen() {
    this.cartPopUp = true;
  }

  closeCart() {
    this.cartPopUp = false;
  }

  quickOrder(): void {
    const posId = Number(localStorage.getItem('posId'));

    this.UserService.getWarehouseType(posId).subscribe({
      next: ({ warehouses_type }) => {
        const type = Number(warehouses_type);

        if ([2, 3, 4].includes(type)) {
          this.router.navigate(['/Addorderstore'], {
            queryParams: {
              cart: JSON.stringify(this.cartItems)
            }
          });
          return;
        }

        else if (type === 1) {
          this.router.navigate(['/Addorderwarehouse'], {
            queryParams: {
              cart: JSON.stringify(this.cartItems)
            }
          });
          return;
        }

        else {
          this.router.navigate(['/Addorder'], {
            queryParams: {
              cart: JSON.stringify(this.cartItems)
            }
          });
          return;
        }
      },
      error: (err) => console.error(err),
    });
  }
  /* =========================
        LANGUAGE
  ========================== */

  get currentLanguage(): string {
    return localStorage.getItem('language') || 'en';
  }

  toggleLanguageDropdown(event?: Event): void {
    event?.stopPropagation();
    if (localStorage.getItem('blueboxSidebarClosed') === 'true') {
      window.dispatchEvent(new CustomEvent('bluebox-sidebar-open-requested'));
      this.languageDropdownOpen = true;
      return;
    }

    this.languageDropdownOpen = !this.languageDropdownOpen;
  }

  setLanguage(lang: string, event?: Event) {
    event?.stopPropagation();
    this.i18.setLanguage(lang);
    this.languageDropdownOpen = false;
  }

  toggleLanguage() {
    this.i18.toggleLanguage();
  }

  /* =========================
        LOGOUT
  ========================== */

  logout() {
    this.logoutService.logout(localStorage.getItem('token'))
      .pipe(takeUntil(this.destroy$))
      .subscribe(() => {
        localStorage.removeItem('username');
        localStorage.removeItem('user_type');
        localStorage.removeItem('access_pages');
        localStorage.removeItem('cart');
        localStorage.removeItem('cartWarehouseId');
        localStorage.removeItem('token');
        window.location.reload();
      });
  }
}
